export enum FilterType {
  NONE = 'none',
  GLOBAL = 'global',
  TEXT = 'text',
  NUMERIC = 'numeric',
  SELECT = 'select',
  MSELECT = 'mselect',
  DATE = 'date',
  MONTH = 'month',
}
